import React from 'react'
import renderHTML from 'react-render-html'
import Slider from 'react-slick'
import './slick.css'
import './slick-theme.css'
import './styles.scss'

export class AppReview extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: window.innerWidth < 768
    }
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    }

    return (
      <div className='ui container'>
        <div className='ui card shadowed'>
          <div className='content'>
            <div className='header'>
              <div className='title'>
                <div className='app'>
                  <img src={this.props.icon} />
                </div>
                <h2>{this.props.title}</h2>
              </div>
              <div className='subtitle'>{this.props.subtitle}</div>
              <div className='meta'>
                <div className='price ui tag label'>{this.props.price}</div>
              </div>
            </div>
            <div className='description'>
              {renderHTML(this.props.description)}
            </div>
            {this.props.screenshots.length > 0 && (
              <Slider {...settings}>
                {this.props.screenshots.map((e, idx) => (
                  <div key={idx} className='screenshots'>
                    <img src={e.image} />
                  </div>
                ))}
              </Slider>
            )}
            <div className='extra content'>
              <div className='audience ui label'>
                <i className='users icon large' /> {this.props.audience}
              </div>
              <div className='strength ui label'>
                <i className='plus circle icon large' /> {this.props.strength}
              </div>
              <div className='weakness ui label'>
                <i className='minus circle icon large' /> {this.props.weakness}
              </div>
              <div
                className={
                  this.props.appStore === undefined ||
                  this.props.playStore === undefined
                    ? 'downloads single'
                    : 'downloads'
                }
              >
                {this.props.appStore !== undefined && (
                  <a
                    href={this.props.appStore}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <button className='ui apple button small'>
                      <i className='apple icon' />
                      App-Store
                    </button>
                  </a>
                )}
                {this.props.playStore !== undefined && (
                  <a
                    href={this.props.playStore}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <button
                      className='ui google button small'
                      style={{ float: 'right' }}
                    >
                      <i className='google play icon' />
                      Google Play
                    </button>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AppReview
